import Cookie from "js-cookie";
import React from "react";
import { FormattedMessage } from "react-intl";

const locale = Cookie.get("locale") || "en";
const languageWithoutRegionCode = locale.toLowerCase().split(/[_-]+/)[0];

export const insertDataMasterOnSessionStorage = (type, data, forceRefresh) => {
  if (sessionStorage.getItem(type) === null || forceRefresh) {
    // console.log(type.toUpperCase() + " don't exist on local storage. Saving " + type + "...");
    sessionStorage.setItem(type, JSON.stringify(data));
    console.log(type.toUpperCase() + " saved on session storage");
  }
};

export const checkForSessionStorageSupport = () => {
  // localStorage detection
  function supportsSessionStorage() {
    return typeof Storage !== "undefined";
  }

  // Run the support check
  if (!supportsSessionStorage()) {
    console.log("No HTML5 sessionStorage Support");
  } else {
    console.log("HTML5 sessionStorage Support");
  }
};

export const checkJSON = (object) => {
  try {
    return JSON.parse(object)[languageWithoutRegionCode];
  } catch (e) {
    return object;
  }
};

export const arrayFunctionFilter = (array, idToFind, fieldToCompare) => {
  var objectArray = JSON.parse(sessionStorage.getItem(array));
  if (objectArray) {
    var y = Object.keys(objectArray)
      .filter((key) => objectArray[key][fieldToCompare] === idToFind)
      .map((key) => {
        return objectArray[key] || null;
      });
    return y[0] || null;
  }
  return null;
};

export const messageResultCode = (resultCode) => {
  console.log("resultCode", resultCode);
  let messageCode;
  switch (resultCode) {
    case 203:
      messageCode = (
        <FormattedMessage
          defaultMessage="Salida"
          id="ticket.exit"
          tagName="n"
        />
      );
      break;
    case 601:
      messageCode = (
        <FormattedMessage
          defaultMessage="Entrada no válida"
          id="error.ticket.not.valid"
          tagName="n"
        />
      );
      break;
    case 602:
      messageCode = (
        <FormattedMessage
          defaultMessage="Entrada fuera de horario"
          id="error.ticket.out.schedule"
          tagName="n"
        />
      );
      break;
    case 603:
      messageCode = (
        <FormattedMessage
          defaultMessage="Entrada fecha errónea"
          id="error.date.ticket"
          tagName="n"
        />
      );
      break;
    case 604:
      messageCode = (
        <FormattedMessage
          defaultMessage="Acceso erróneo"
          id="error.access"
          tagName="n"
        />
      );
      break;
    case 605:
      messageCode = (
        <FormattedMessage
          defaultMessage="Máximo de usos agotado"
          id="error.max.uses"
          tagName="n"
        />
      );
      break;
    case 606:
      messageCode = (
        <FormattedMessage
          defaultMessage="Entrada utilizada"
          id="error.used.ticket"
          tagName="n"
        />
      );
      break;
    case 607:
      messageCode = (
        <FormattedMessage
          defaultMessage="No requiere validación"
          id="error.validation.not.required"
          tagName="n"
        />
      );
      break;
    case 608:
      messageCode = (
          <FormattedMessage
              defaultMessage="Aforo completo"
              id="error.venue.full"
              tagName="n"
          />
      );
      break;
    case 100:
      messageCode = (
        <FormattedMessage
          defaultMessage="Unknown case"
          id="error.unknown"
          tagName="n"
        />
      );
      break;
    default:
      messageCode = "";
      break;
  }
  return messageCode;
};

export const getFieldValue = (object, field) => {
  const value = object !== undefined ? object[field] : " ";
  return value;
};

export const getNameVenueORExtra = (object) => {
  let field, storageKey, objectFiltered;
  if (object.ticketExtraId !== null) {
    storageKey = "extras";
    field = "extraId";
  } else {
    storageKey = "venuecapacities";
    field = "venueCapacityId";
  }

  objectFiltered = arrayFunctionFilter(
    storageKey,
    object.venueCapacityORExtraId,
    field
  );

  return checkJSON(objectFiltered.name);
};

export const getVenueNameFromTicket = (object) => {
  var venue, venueCapacityId, event, nameVenue;

  try {
    event = arrayFunctionFilter("events", object.eventId, "eventId");
    if (event) venueCapacityId = event.venueCapacityId;
  } catch (e) {
    console.log(e);
    return null;
  }

  if (venueCapacityId) {
    venue = arrayFunctionFilter(
      "venuecapacities",
      venueCapacityId,
      "venueCapacityId"
    );
    if (venue) nameVenue = venue.name;
  }
  return nameVenue ? checkJSON(nameVenue) : null;
};

export const getExtraNamefromTicket = (extraId) => {
  let nameExtra = arrayFunctionFilter("extras", extraId, "extraId").name;

  return checkJSON(nameExtra);
};

export const getBuyerTypeName = (buyerTypeId, resultCode) => {
  let buyerTypeName = arrayFunctionFilter(
    "buyertypes",
    buyerTypeId,
    "buyerTypeId"
  ).name;
  if (buyerTypeName) {
    return checkJSON(buyerTypeName);
  } else {
    return "Sin colectivo";
  }
};

export const getBuyerTypeColor = (buyerTypeId) => {
  let buyerType = arrayFunctionFilter("buyertypes", buyerTypeId, "buyerTypeId");

  if (buyerType && buyerType.requiresPdaAlert && buyerType.alertColor) {
    return buyerType.alertColor;
  } else {
    return null;
  }
};

export const getPromotionColor = (promotionId) => {
  let promotion = arrayFunctionFilter("promotions", promotionId, "promotionId");

  if (promotion.requiresPdaAlert && promotion.alertColor) {
    return promotion.alertColor;
  } else {
    return null;
  }
};

export const getPromotionName = (promotionId) => {
  let namePromotion = arrayFunctionFilter(
    "promotions",
    promotionId,
    "promotionId"
  ).name;

  return checkJSON(namePromotion);
};

export const getEventStartDate = (eventId) => {
  let event = arrayFunctionFilter("events", eventId, "eventId");
  if (event) {
    return event.startDatetime;
  } else {
    return "";
  }
};

export const getEventEndDate = (eventId) => {
  let event = arrayFunctionFilter("events", eventId, "eventId");
  if (event) {
    return event.endDatetime;
  } else {
    return "";
  }
};

export const arrayConversion = (array, idName) => {
  let result = [];
  array
    .filter((item) => result.indexOf(item[idName]) <= -1)
    .map((item) => result.push(item[idName]));

  return result || [];
};

export const validationModes = {
  automatic: 1,
  manual: 2,
  offline: 3,
  override: 4,
};

// Compare two objects by keys
export const equalForKeys = (a, b, keys) => {
  if (!keys) {
    keys = [];
    for (const n in a) keys.push(n); // Used instead of Object.keys() for IE8 compatibility
  }

  for (let i = 0; i < keys.length; i++) {
    const k = keys[i];
    if (a[k] !== b[k]) return false; // Not '===', values aren't necessarily normalized
  }
  return true;
};
